export default {
  title: 'Partners',
  search_placeholder: 'Buscar partner...',
  buttons: {
    default_price_list: 'Lista de precios predeterminada',
    create_partner: 'Crear partner',
  },
  columns: {
    name: 'Nombre',
    restaurants: 'Restaurantes',
    shop_domain: 'Dominio de tienda',
    status: 'Estado',
    earning_enabled: 'Ganancias habilitadas',
  },
  statuses: {
    invited: 'Invitado',
    active: 'Activo',
    suspended: 'Suspendido',
  },
  actions: {
    edit: 'Editar',
    view_billing: 'Ver facturación',
    view_as_partner: 'Ver como socio',
    suspend: 'Suspender',
    unsuspend: 'Reactivar',
  },
  suspension: {
    suspend_title: '¿Suspender este socio?',
    suspend_description:
      'Todos los miembros del equipo del socio serán desactivados y sus sesiones revocadas. Sus restaurantes permanecen activos.',
    unsuspend_title: '¿Reactivar este socio?',
    unsuspend_description:
      'Todos los miembros del equipo del socio serán reactivados y podrán iniciar sesión de nuevo.',
  },
  toasts: {
    load_error: 'No se pudieron cargar los socios.',
    suspended: 'El socio ha sido suspendido.',
    unsuspended: 'El socio ha sido reactivado.',
    suspension_error: 'No se pudo cambiar el estado del socio.',
    view_as_error: 'No se pudo abrir el panel del socio.',
  },
};
